import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Layer = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.94486 2.44282C7.78504 1.92044 8.85425 1.94267 9.67199 2.49952L13.6751 5.22542C14.2579 5.62233 14.2579 6.48164 13.6751 6.87854L9.67199 9.60445C8.85425 10.1613 7.78504 10.1835 6.94486 9.66115L2.50582 6.90122C1.87649 6.50995 1.87649 5.59402 2.50582 5.20274L6.94486 2.44282ZM10.2348 1.67296C9.08999 0.893372 7.59311 0.862251 6.41685 1.59358L1.97781 4.3535C0.719161 5.13605 0.719164 6.96791 1.97781 7.75046L2.37908 7.99994L1.9778 8.24943C0.71915 9.03199 0.719152 10.8638 1.9778 11.6464L6.41684 14.4063C7.5931 15.1376 9.08998 15.1065 10.2348 14.3269L14.2379 11.601C15.4036 10.8072 15.4036 9.08861 14.2379 8.29479L13.8049 7.99995L14.2379 7.7051C15.4037 6.91129 15.4037 5.19267 14.2379 4.39886L10.2348 1.67296ZM12.9166 8.60487L10.2348 10.431C9.09 11.2106 7.59311 11.2417 6.41685 10.5104L3.32604 8.58871L2.50581 9.09867C1.87648 9.48995 1.87648 10.4059 2.50581 10.7972L6.94485 13.5571C7.78503 14.0795 8.85423 14.0572 9.67198 13.5004L13.6751 10.7745C14.2579 10.3776 14.2579 9.51826 13.6751 9.12135L12.9166 8.60487Z"
        fill={color}
      />
    </svg>
  )
})

export default Layer
